import { render, staticRenderFns } from "./ChatBotList.vue?vue&type=template&id=341bf3db&scoped=true&"
import script from "./ChatBotList.vue?vue&type=script&lang=js&"
export * from "./ChatBotList.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotList.vue?vue&type=style&index=0&id=341bf3db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341bf3db",
  null
  
)

export default component.exports